import styled from 'styled-components';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

export const CategoryTitle = styled.h5<WithStyleVariant>`
  height: 3rem;
  flex-wrap: wrap;
  margin: 0rem;
  display: flex;
  align-items: center;
  color: ${({ variant }) =>
    variant === RewardsStyleVariant.Secondary ? Styles.color.white : Styles.color.secondary};
  font-weight: ${({ variant }) =>
      variant === RewardsStyleVariant.Secondary ? Styles.fontWeight.normal : 'inherit'}
    ${Styles.desktop`
  font-size:1.2rem;
`};
`;
